<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    xml:space="preserve">
    <g>
      <g>
        <rect
          x="-1.814"
          y="13.086"
          transform="matrix(0.7071 -0.7071 0.7071 0.7071 -7.4706 10.9645)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          width="22.627"
          height="2.828" />

        <line
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="20.052"
          y1="4"
          x2="22.5"
          y2="1.5" />

        <line
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="13"
          y1="4"
          x2="10.5"
          y2="1.5" />

        <line
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="22.5"
          y1="13.5"
          x2="20"
          y2="11" />

        <line
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="20.448"
          y1="7.5"
          x2="22.448"
          y2="7.5" />

        <line
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="13"
          y1="9"
          x2="15"
          y2="11" />

        <line
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="16.5"
          y1="3.5"
          x2="16.5"
          y2="1.5" />
      </g>
    </g>
  </svg>
</template>
